import { useState, useCallback } from "react";
import { Snackbar, Alert, AlertTitle } from "@mui/material";

const DEFAULT_AUTO_HIDE_MS = 3000;

const useAlert = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
    title: "",
    autoHideDuration: DEFAULT_AUTO_HIDE_MS,
  });

  const showAlert = useCallback((options) => {
    setSnackbar({
      open: true,
      title: "",
      severity: "success",
      message: "",
      autoHideDuration: DEFAULT_AUTO_HIDE_MS,
      ...options,
    });
  }, []);

  const handleClose = (_event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const AlertSnackbar = (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={snackbar.autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar.severity}
        variant="outlined"
        sx={{ width: "100%", bgcolor: "background.paper" }}
      >
        {snackbar.title && <AlertTitle>{snackbar.title}</AlertTitle>}
        {snackbar.message}
      </Alert>
    </Snackbar>
  );

  return { showAlert, AlertSnackbar };
};

export default useAlert;

